module.exports = __webpack_public_path__ + "img/jacket-front-sub-raglan-classic.8fb4b6e1.png";